import { ClientAction } from '@entities/clients';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';

import { useMobile } from '@shared/hooks';
import { MediumHeader } from '@shared/ui';

import { closeActionModal } from '@src/library/redux/modal';

import * as st from './styles.module.scss';

export function ClientsActionsModal() {
	const dispatch = useDispatch();
	const onClose = () => dispatch(closeActionModal());
	const actions = [
		{ title: 'Отправить сообщение', action: () => {} },
		{ title: 'Рекомендовать товар', action: () => {} },
		{ title: 'Пригласить на мероприятие', action: () => {} },
		{ title: 'Рекомендовать видео', action: () => {} },
		{ title: 'Рекомендовать программу', action: () => {} },
		{ title: 'Рекомендовать статью', action: () => {} },
		{ title: 'Импортировать в vcf', action: () => {} },
		{
			title: 'Импортировать в Excel',
			action: () => {
				window.open('/api/v1/users/export/');
			},
		},
		{ title: 'Удалить выбранных клиентов', action: () => {} },
	];

	return (
		<Modal isOpen onRequestClose={onClose} className={st.modal} overlayClassName={st.overlay}>
			<MediumHeader title="Выберите действие" onClose={onClose} />
			<div className={st.list}>
				{actions.map((action, index) => (
					<ClientAction key={index} onClick={action.action} title={action.title} />
				))}
			</div>
		</Modal>
	);
}
